const doc = [({"da":({"js":({"admin":({"highscore_competitions":({"table":({"the_competition_was_removed_from_the_highscore":"Konkurrencen blev fjernet fra highscoren"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;